import { Event } from '~/Features/Messaging/types';

interface LockedWithScrollBar {
    isLocked: true;
    isScrollBarVisible: true;
}

interface LockedWithoutScrollBar {
    isLocked: true;
    isScrollBarVisible: false;
    scrollBarWidth: number;
}

interface Unlocked {
    isLocked: false;
}

export type ScrollLockState = LockedWithScrollBar | LockedWithoutScrollBar | Unlocked;

export class ScrollLockUpdated extends Event {
    public static readonly id = 'ScrollLockUpdated';

    constructor(public readonly state: ScrollLockState) {
        super(ScrollLockUpdated.id);
    }
}
